import React from "react";
import { Link } from "react-router-dom";
import icons from "../constants/icons.ts";
import images from "../constants/images.ts";
import { footerLinks, socialLinks } from "../constants/data.ts";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-secondary text-white">
      {/* Main Footer Content */}
      <div className="container mx-auto px-outer py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Logo & Description */}
          <div>
            <div className="flex flex-col items-center text-center">
              <img
                src={images.brand.logo}
                alt="Westlisoft Logo"
                className="mb-3 h-20 w-auto"
              />
              <p className="font-rubik text-xl font-bold leading-tight text-primary">
                WESTLISOFT
                <span className="block text-base">Technologies PVT LTD</span>
              </p>
            </div>
          </div>

          {/* Company Links */}
          <div>
            <h4 className="font-rubik font-bold text-white mb-4">Company</h4>
            <ul className="space-y-2">
              {footerLinks.Company.map((link, index) => (
                <li key={index}>
                  <Link
                    to={link.path}
                    className="text-gray-300 hover:text-primary transition-colors font-rubik font-light text-sm"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Resources Links */}
          <div>
            <h4 className="font-rubik font-bold text-white mb-4">Resources</h4>
            <ul className="space-y-2">
              {footerLinks.Resources.map((link, index) => (
                <li key={index}>
                  <Link
                    to={link.path}
                    className="text-gray-300 hover:text-primary transition-colors font-rubik font-light text-sm"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="font-rubik font-bold text-white mb-4">
              Get In Touch
            </h4>
            <ul className="space-y-3">
              {footerLinks.Contact.map((contact, index) => (
                <li key={index}>
                  <a
                    href={contact.href}
                    className="flex items-center gap-2 text-gray-300 hover:text-primary transition-colors font-rubik font-light text-sm"
                  >
                    <i className={`${contact.icon} w-4`}></i>
                    {contact.label}
                  </a>
                </li>
              ))}
            </ul>
            {/* Social Links */}
            <div className="flex gap-4 mt-4">
              {socialLinks.map((social, index) => (
                <a
                  key={index}
                  href={social.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-white hover:text-primary transition-colors"
                >
                  <i className={`${social.icon} text-lg`}></i>
                </a>
              ))}
            </div>
          </div>
          
        </div>

        {/* Divider */}
        <hr className="border-gray-700 my-8" />

        {/* Bottom Footer */}
        <div className="flex flex-col gap-3 md:flex-row md:justify-between md:items-center text-gray-300 text-sm font-rubik font-light">
          <p>&copy; {currentYear} Westlisoft Solutions. All rights reserved.</p>
          <div className="flex flex-wrap gap-4 justify-center">
            <Link to="/disclaimer" className="hover:text-primary transition-colors">
              Disclaimer
            </Link>
            <Link to="/privacy" className="hover:text-primary transition-colors">
              Privacy Policy
            </Link>
            <Link to="/faqs" className="hover:text-primary transition-colors">
              FAQ&apos;s
            </Link>
            <Link to="/terms" className="hover:text-primary transition-colors">
              Terms & Conditions
            </Link>
          </div>
          <p>
            Designed with <i className={`${icons.actions.heart} text-primary`}></i> by
            Westlisoft Team
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
